export const mapboxToken =
  process.env.MAPBOX_TOKEN_CAREGIVERS || process.env.MAPBOX_TOKEN;
